import type { SVGProps } from 'react';

export const FlagIcon = (attrs: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attrs}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46982 2.77709C9.46982 2.77709 10.7556 2.09091 11.7273 2.09091C12.5008 2.1122 13.2526 2.33574 13.9091 2.73577V9.13393C13.2276 8.81364 12.4835 8.64324 11.7273 8.63636C10.8144 8.67138 9.91909 8.89807 9.09963 9.30182C8.34943 9.74287 7.50513 9.99924 6.63636 10.0499C4.81819 10.0499 4.09091 8.97269 4.09091 8.97269V2.79782C4.09091 2.79782 4.81819 3.46327 6.63636 3.46327C7.61956 3.44377 8.58662 3.20957 9.46982 2.77709ZM4.09091 1.33636V1.32255H3V16.5953H4.09091V10.3313C4.09091 10.3313 4.81819 11.0996 6.63636 11.0996C7.61956 11.0801 8.58662 10.8459 9.46982 10.4135C9.46982 10.4135 10.7556 9.72727 11.7273 9.72727C12.6204 9.73535 13.4966 9.97153 14.2727 10.4135L15 10.8938V10.0499V9.80287V3.25745V2.31709V2.16654L14.2727 1.68618C13.4966 1.24428 12.6204 1.00807 11.7273 1C10.8144 1.03496 9.91909 1.2617 9.09963 1.66545C8.34943 2.10647 7.50513 2.36284 6.63636 2.41346C4.81819 2.41346 4.09091 1.33636 4.09091 1.33636Z"
        fill="currentColor"
      />
    </svg>
  );
};
